import { ErrorMessage, Field, useFormikContext } from "formik";
import React from "react";
import { NMPClassification } from "./nmpClassificationTree.api";

type Props = {
	classification: NMPClassification;
	isView?: boolean;
};

const NMPClassificationStep: React.FC<Props> = ({ classification, isView = false }) => {
	const { values } = useFormikContext<any>();
	const isAuditPara = classification?.name?.trim().toLowerCase() === "audit para";

	return (
		<div className="w-100">
			{classification.categories.map((category) => (
				<div key={category.id} className="mb-8">
					<div className="text-primary fw-bolder fs-6 text-uppercase mb-4">
						Category: {category.name}
					</div>
					<div className="d-flex flex-column gap-8">
						{category.sub_categories.map((sub, index) => {
							const fieldId = `subcat_${sub.id}`;
							const currentValue = values[fieldId];

							return (
								<div
									key={sub.id}
									className="card border-0 shadow-sm rounded-4 bg-light"
								>
									<div className="card-body p-6">
										<div className="d-flex align-items-start mb-6">
											<div className="symbol symbol-40px me-4 mt-1">
												<span className="symbol-label bg-white shadow-sm text-primary fw-bolder fs-5 rounded-circle">
													{index + 1}
												</span>
											</div>
											<label className="text-dark fw-bolder mb-0 fs-3 lh-base required">
												{sub.code && (
													<span className="badge badge-light-primary me-2">
														{sub.code}
													</span>
												)}
												{sub.name}
											</label>
										</div>

										<div className="row g-5">
											<div className="col-12">
												<div className="bg-white p-4 rounded-3 shadow-sm h-100 border border-gray-200">
													<label className="text-muted fw-bold fs-7 text-uppercase mb-3 d-block">
														Observation Status
													</label>
													<div className="d-flex flex-wrap gap-3">
														{["Yes", "No", "Unknown", "Not Applicable"].map(
															(option, i) => {
																const optionValue = option.toLowerCase();
																const isActive = currentValue === optionValue;

																let activeClass = "";
																if (isActive) {
																	if (optionValue === "yes")
																		activeClass = "btn-primary text-white";
																	else if (optionValue === "no")
																		activeClass = "btn-danger text-white";
																	else if (optionValue === "not applicable")
																		activeClass = "btn-secondary text-dark";
																	else activeClass = "btn-warning text-dark";
																} else {
																	activeClass =
																		"btn-outline btn-outline-dashed btn-outline-default btn-active-light";
																}

																return (
																	<div key={option} className="flex-grow-1">
																		<Field
																			className="btn-check"
																			name={fieldId}
																			id={`${fieldId}_${i}`}
																			type="radio"
																			value={optionValue}
																			disabled={isView}
																		/>
																		<label
																			className={`btn ${activeClass} d-flex align-items-center justify-content-center fw-bolder px-4 py-3 w-100 fs-5`}
																			htmlFor={`${fieldId}_${i}`}
																			style={{ transition: "all 0.2s ease" }}
																		>
																			{option === "Not Applicable" ? "N/A" : option}
																		</label>
																	</div>
																);
															},
														)}
													</div>
													<div className="text-danger mt-2 fw-bold fs-7">
														<ErrorMessage name={fieldId} />
													</div>

													{currentValue === "yes" && (
														<div className="mt-4">
															<label
																className={`text-muted fw-bold fs-7 text-uppercase mb-2 d-block ${
																	isAuditPara ? "required" : ""
																}`}
															>
																Remarks
															</label>
															<Field
																as="textarea"
																name={`${fieldId}_remarks`}
																className="form-control form-control-solid"
																rows={3}
																disabled={isView}
																placeholder="Add details..."
															/>
															{isAuditPara && (
																<div className="text-danger mt-1 fw-bold fs-7">
																	<ErrorMessage name={`${fieldId}_remarks`} />
																</div>
															)}
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			))}
		</div>
	);
};

export default NMPClassificationStep;
